<template>
  <tr v-if="files.filter(f => f.shared || false).length > 0">
    <td>
      {{ $t(title) }}
    </td>
    <td>
      <b-tag
        v-for="(file, index) in files.filter(f => f.shared || false)"
        :key="index"
        ><a :href="file.url || file.s3ObjectLocation" target="_blank">{{
          file.name
        }}</a>
        {{ fromUnix(file.createdAt) }}</b-tag
      >
    </td>
  </tr>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    files: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    fromUnix(val) {
      if (!val) {
        return ''
      }
      return moment
        .unix(val.substr(0, val.length - 3))
        .tz('Europe/Madrid')
        .format('DD-MM-YYYY, h:mm:ss a')
    }
  }
}
</script>
